module.exports = __webpack_public_path__ + "img/P27-en.e3be6229.png";